import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import Tooltip from "./Tooltip";

const iconTintClasses = [
    "bg-primary-50 text-primary-500",
    "bg-secondary-50 text-secondary-600",
    "bg-energi-100 text-energi-800",
    "bg-kraft-100 text-kraft-700",
    "bg-success-50 text-success-600",
];



const toneBarFillClasses = {
    positive: "bg-secondary-600",
    neutral: "bg-primary-500",
    caution: "bg-warning-600",
    critical: "bg-error-500",
};

function HeaderStatisticsItems({ icon, title, titleHint, value, iconTintIndex = 0, tone, barPercent }) {
    const { t } = useTranslation();
    const safeTint = Number.isFinite(iconTintIndex) ? Math.abs(Math.floor(iconTintIndex)) % iconTintClasses.length : 0;
    const iconCircleClass = iconTintClasses[safeTint];
    const barFillClass =
        tone && toneBarFillClasses[tone] ? toneBarFillClasses[tone] : "bg-primary-500";

    const showBar = typeof barPercent === "number" && Number.isFinite(barPercent);

    return (
        <div
            className="flex h-full items-start gap-3 rounded-xl border border-mute-200 bg-white p-4 shadow-md transition-shadow duration-200"
        >
            {icon ? (
                <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full ${iconCircleClass}`}>
                    <FontAwesomeIcon icon={icon} className="text-lg" />
                </div>
            ) : (
                <div className="h-12 w-12 shrink-0" aria-hidden="true" />
            )}
            <div className="flex min-w-0 flex-1 flex-col gap-1">
                <div className="flex items-start gap-1.5" data-stat-title="">
                    <p className="m-0 text-sm font-normal leading-5 text-mute-600">{title}</p>
                    {titleHint ? (
                        <Tooltip
                            content={titleHint}
                            position="right"
                            tooltipClassName="max-w-sm"
                        >
                            <span
                                className="inline-flex shrink-0 cursor-help text-mute-400 hover:text-mute-600"
                                aria-label={titleHint}
                            >
                                <FontAwesomeIcon icon={faInfoCircle} className="h-3.5 w-3.5" />
                            </span>
                        </Tooltip>
                    ) : null}
                </div>
                <p className="text-lg font-bold leading-7 tabular-nums text-mute-900 md:text-xl lg:text-xl xl:text-2xl">
                    {value}
                </p>
                {showBar ? (
                    <div
                        className="h-1.5 w-full overflow-hidden rounded-full bg-mute-200"
                        role="progressbar"
                        aria-valuemin={0}
                        aria-valuemax={100}
                        aria-valuenow={Math.round(barPercent)}
                        aria-label={`${title}: ${Math.round(barPercent)} ${t("common.percent")}`}
                    >
                        <div
                            className={`h-full rounded-full transition-[width] duration-300 ${barFillClass}`}
                            style={{ width: `${Math.min(100, Math.max(0, barPercent))}%` }}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default HeaderStatisticsItems;
